
/**
 * Confirmation modal script
 */

(function($){
    
    var confirmElements = $('.js-confirm-form');
    var theForm = {};

    // for each element add the event to ask for confirmation
    confirmElements.on('click', function(e){
        e.preventDefault();
        theForm.el = $(this);
        $('#myModal').modal('show');
    });

    $('#myModal').on('show.bs.modal', function () {

        var yesButton = $(this).find('.button-yes');
        var noButton = $(this).find('.button-no');

        // do something...
        yesButton.on('click', function () {
            theForm.el.submit();
        });

    });
    
    
    
})(jQuery);